import { render, staticRenderFns } from "./DeleteRoleCard.vue?vue&type=template&id=6117c83a&scoped=true&"
import script from "./DeleteRoleCard.vue?vue&type=script&lang=ts&"
export * from "./DeleteRoleCard.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteRoleCard.vue?vue&type=style&index=0&id=6117c83a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6117c83a",
  null
  
)

export default component.exports
import {QCard,QCardSection,QCardActions} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QCardActions})
